// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0da14881","710":"c0147b45"}[chunkId] + ".chunk.js";
};